import { D, Flight } from "./segmentEngine"

/**
 * Context for where to draw a segment boundary: the campaign's own edges, the next billing
 * cycle, the next replenish. Read-only — never draggable and never a click target on the
 * track, so block edges stay grabbable.
 *
 * Campaign edges are slate and solid (structure); billing and replenish are state, and
 * dashed so they read as "upcoming" rather than as a wall.
 *
 * They are the CAMPAIGN's dates, not a "flight" — MPN-2040 makes the campaign's start and
 * end the single source of truth, set on the Campaign page and shown read-only here. The
 * prototype renamed these markers to match, and the two words meaning the same thing was
 * exactly the ambiguity that ticket exists to remove.
 */
export type KeyDate = {
  k: string
  label: string
  date: string
  color: string
  solid?: boolean
  /** The campaign's end marks the close of its day, so it sits on the following boundary. */
  endOfDay?: boolean
}

export type KeyDateInput = {
  flight: Flight
  /** The engagement's own window; markers outside it are dropped. */
  windowStart: string
  windowEnd: string
  nextBillingDate?: string | null
  nextReplenishDate?: string | null
}

export const keyDates = (input: KeyDateInput): KeyDate[] => {
  const out: KeyDate[] = [
    { k: "fs", label: "Campaign start", date: input.flight.start, color: "#475569", solid: true },
    { k: "fe", label: "Campaign end", date: input.flight.end, color: "#475569", solid: true, endOfDay: true },
  ]
  // Only a dated cycle gets a marker: a flat-fee engagement has no billing date to show.
  if (input.nextBillingDate)
    out.push({ k: "bill", label: "Next billing cycle", date: input.nextBillingDate, color: "#6366f1" })
  if (input.nextReplenishDate)
    out.push({ k: "rep", label: "Next replenish", date: input.nextReplenishDate, color: "#059669" })

  return out.filter((m) => D(m.date) >= D(input.windowStart) && D(m.date) <= D(input.windowEnd))
}
